import { render, staticRenderFns } from "./newPlanUploadNew.vue?vue&type=template&id=2dab79dc&scoped=true"
import script from "./newPlanUploadNew.vue?vue&type=script&lang=js"
export * from "./newPlanUploadNew.vue?vue&type=script&lang=js"
import style0 from "./newPlanUploadNew.vue?vue&type=style&index=0&id=2dab79dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab79dc",
  null
  
)

export default component.exports